import { render, staticRenderFns } from "./CompanyReservations.vue?vue&type=template&id=f42ce704&"
import script from "./CompanyReservations.vue?vue&type=script&lang=js&"
export * from "./CompanyReservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports